export const getBrandColorShadeFromHex = (
  primaryColor: string,
  valueOfL: number,
  shade?: string
) => {
  const rgbColorFormat = hexToRgb(primaryColor);
  return computeColorShade(rgbColorFormat, valueOfL, shade);
};

export const getBrandColorShadeFromRgb = (
  primaryColor: [number, number, number],
  valueOfL: number,
  shade?: string
) => {
  return computeColorShade(primaryColor, valueOfL, shade);
};

const computeColorShade = (
  primaryColor: [number, number, number],
  valueOfL: number,
  shade?: string
) => {
  // The default RGB is gray 400
  const primaryShade = primaryColor || [160, 174, 192];
  // Convert the RGB value to HSL
  const hslColor = rgbToHsl(...primaryShade);

  let lightness = hslColor[2] + (100 - hslColor[2]) * valueOfL;
  if (shade === "dark") lightness = hslColor[2] - hslColor[2] * valueOfL;

  if (hslColor[1] > 100 && shade === "dark") hslColor[1] = 99;
  // Convert the HSL value to Hex
  const hexColor = hslToHex(hslColor[0], hslColor[1], lightness);
  return hexColor;
};

// Function to convert RGB to HSL
const rgbToHsl = (
  r: number,
  g: number,
  b: number
): [number, number, number] => {
  r /= 255;
  g /= 255;
  b /= 255;
  const l = Math.max(r, g, b);
  const s = l - Math.min(r, g, b);
  const h =
    s !== 0
      ? l === r
        ? (g - b) / s
        : l === g
          ? 2 + (b - r) / s
          : 4 + (r - g) / s
      : 0;

  return [
    60 * (h < 0 ? h + 6 : h),
    100 * (s ? s / (l < 0.5 ? 2 * l : 2 - 2 * l) : 0),
    100 * l
  ];
};

// Function to convert HSL to Hex Code
const hslToHex = (h: number, s: number, l: number) => {
  h /= 360;
  s /= 100;
  l /= 100;
  let r: number, g: number, b: number;
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p: number, q: number, t: number) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  const toHex = (x: number) => {
    if (x > 1) x = 0.99;
    const hex = Math.round(x * 255).toString(16);
    return hex.length === 1 ? "0" + hex : hex;
  };
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

// Function to convert Hex to RGB Code
const hexToRgb = (hex: string): [number, number, number] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
      ]
    : null;
};

/**
 *
 * To convert to rgbColor
 * Use: hslToRgb(hslColor[0], hslColor[1], lightness);
 * Print: #${rgbToHex(rgbColor[0])}${rgbToHex(rgbColor[1])}${rgbToHex(rgbColor[2])}
 * @returns
 */

// Function to convert HSL to RGB
// const hslToRgb = (
//   h: number,
//   s: number,
//   l: number
// ): [number, number, number] => {
//   s /= 100;
//   l /= 100;
//   const k = (n: number) => (n + h / 30) % 12;
//   const a = s * Math.min(l, 1 - l);
//   const f = (n: number) =>
//     l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));

//   return [
//     Math.abs(Math.round(255 * f(0))),
//     Math.abs(Math.round(255 * f(8))),
//     Math.abs(Math.round(255 * f(4)))
//   ];
// };

// Function to convert RGB to Hex Code
// const rgbToHex = (num: number) => {
//   const hex = num.toString(16);
//   return hex.length === 1 ? "0" + hex : hex;
// };
